import LTR from "@brand-icons/ploom/gen4-auto-on/gen4-auto-on-ltr.svg";

import { iconFactory } from "../iconFactory";

export const Gen4AutoOnIcon = iconFactory("Gen4AutoOnIcon", LTR);
